import React, { useState, useReducer, useRef, useEffect, useImperativeHandle, forwardRef, Fragment } from "react";
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { SelectButton } from 'primereact/selectbutton';

import FormButton from "../../../UI/Button/FormButton/FormButton";
// src/components/UI/Button/FormButton/FormButton.js
import CustomDropDown from "../../../CustomDropDown/CustomDropDownWithIcon";

import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import classes from './EditPinForm.module.css';

// import { serviceActions } from "../../../store/service-Slice";
import Input from "../../../CustomDropDown/Input/Input";
import ToggleInput from "../../ToggleInput";
import Button1 from "../../Button/Button1";


import Camera from "../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/camera_grey.png";
import Gate from "../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/gate_grey.png";
import Door from "../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/door_grey.png";
import alarm from "../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/alarm_grey.png"
import Default from "../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/default_grey.png"
import Speaker from "../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/speaker_grey.png"

import { clearDeviceLogs } from "../../../../Api Methods/Api";
import CustomDropDownWithIcon from "../../../CustomDropDown/CustomDropDownWithIcon";
import SelectIcon from "./SelectIcon";
import { read } from "sheetjs-style";

const extraLinks = [
    {
        LinkTextBold: "Subscribe to get release emails",
    },
]

const accessLevelOptions = [
    { label: "Admin", value: "admin" },
    { label: "Manager", value: "manager" },
    { label: "Any", value: "user" },
]

const PinNameReducer = (state, action) => {

    if (action.type === 'USER_INPUT') {
        return { value: action.val, isValid: action.val.length > 0 };
    }

    if (action.type === 'INPUT_BLUR') {
        return { value: state.value, isValid: state.value.length > 0 };
    }

    if (action.type === 'INPUT_CLEAR') {
        return { value: action.val, isValid: null };
    }
    //otherwise 
    return { value: '', isValid: false };
}

const onStatusReducer = (state, action) => {

    if (action.type === 'USER_INPUT') {
        return { value: action.val, isValid: action.val.length > 0 };
    }

    if (action.type === 'INPUT_BLUR') {
        return { value: state.value, isValid: state.value.length > 0 };
    }

    if (action.type === 'INPUT_CLEAR') {
        return { value: action.val, isValid: null };
    }
    //otherwise 
    return { value: '', isValid: false };
}

const offStatusReducer = (state, action) => {

    if (action.type === 'USER_INPUT') {
        return { value: action.val, isValid: action.val.length > 0 };
    }

    if (action.type === 'INPUT_BLUR') {
        return { value: state.value, isValid: state.value.length > 0 };
    }

    if (action.type === 'INPUT_CLEAR') {
        return { value: action.val, isValid: null };
    }
    //otherwise 
    return { value: '', isValid: false };
}

// Reducer function
const switchIconReducer = (state, action) => {
    if (action.type === 'TOGGLE_DROPDOWN') {
        return { ...state, showDropDownOptions: !state.showDropDownOptions, isValid: null };
    }

    if (action.type === 'SELECT_OPTION') {
        return { ...state, selectedOption: action.payload.option, icon: action.payload.icon, showDropDownOptions: false, isValid: action.val != "SwitchIcon" };
    }

    if (action.type === 'BLUR_DROPDOWN') {
        return { ...state, showDropDownOptions: false, isValid: action.payload.option.val != "SwitchIcon" };
    }

    if (action.type === 'INPUT_CLEAR') {
        return { selectedOption: null, isValid: null };
    }
    //otherwise 
    return { state };
};

const PulseLengthReducer = (state, action) => {

    switch (action.type) {
        case 'USER_INPUT':
            const userInput = action.val;
            const userInputNumber = parseInt(userInput, 10);
            const isValidUserInput = userInput == '' || (!isNaN(userInputNumber) && userInputNumber > 0 && userInputNumber <= 600) && userInput.length <= 3;
            return { value: isValidUserInput ? userInput : state.value, isValid: userInput === '' ? null : (!isNaN(userInputNumber) && userInputNumber > 0 && userInputNumber <= 600) };

        case 'INPUT_BLUR':
            const blurInput = state.value;
            const blurInputNumber = parseInt(blurInput, 10);
            const isValidBlurInput = blurInput !== '' && !isNaN(blurInputNumber) && blurInputNumber > 0 && blurInputNumber <= 600;
            return { value: blurInput, isValid: blurInput === '' ? null : isValidBlurInput };

        case 'INPUT_CLEAR':
            return { value: '', isValid: null };

        default:
            return { value: '', isValid: false };
    }
}

function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

function convertSecondsToMinutesAndSeconds(seconds) {
    // if (typeof seconds !== 'number' || seconds < 0) {
    //     throw new Error('Input should be a non-negative number');
    // }
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;

    let minuteText;
    let SecondsText;

    if (minutes < 2) {
        minuteText = "minute";
    } else {
        minuteText = "minutes";
    }

    if (remainingSeconds < 2) {
        SecondsText = "second";
    } else {
        SecondsText = "seconds";
    }


    return `${minutes} ${minuteText} ${remainingSeconds != 0 ? "and" : ""} ${remainingSeconds != 0 ? remainingSeconds : ""} ${remainingSeconds != 0 ? SecondsText : ""}`;
}

const EditPinForm = ({ PinDetails, setNewDeviceDetails, setNewDeviceDetailsExtras, setHasDeviceChanged, setReloadOnSave, deviceDetails, SmartLocks }, props) => {

    console.log(deviceDetails); //Hide 'Action 1 on text (Max 17 characters)' when a lock
    console.log('locks', SmartLocks);
    console.log('pin details', PinDetails);

    const iconMap = {
        camera: Camera,
        gate: Gate,
        door: Door,
        alarm: alarm,
        default: Default,
        speaker: Speaker
    };

    let DeviceDetails

    //Input pins have a further InputPin proptery before being able to pull out device details, so if it's not present then the pin clicked most be a output pin.
    if (!PinDetails.InputPin) {
        DeviceDetails = PinDetails;
    } else {
        DeviceDetails = PinDetails.InputPin;
    }


    const { Pin, pinState, pinName, pinStatusOn, pinStatusOff, actionOneOnLabel, actionOneOffLabel, notificationActive, active, icon, accessLevel, readOnly, type, length, notificationSound, lastSwitchTime, delay, tempLatchAllowed, tempLatchStandardRestriction, preAccessCheck } = DeviceDetails;

    // Output pins linked to a padlock carry a lockID on their entry in deviceDetails.
    const isPadlockOutput = !PinDetails.InputPin && Boolean(SmartLocks?.find(Lock => Lock.outputPin == Pin));
    const [formIsValid, setFormIsValid] = useState(false);

    const [isNotificationsChecked, setIsNotificationsChecked] = useState(notificationActive);
    const [isPreAccessChecked, setIsPreAccessChecked] = useState(preAccessCheck);

    const [isPinActiveChecked, setIsPinActiveChecked] = useState(active);
    const [isTempLatchEnabledChecked, setIsTempLatchEnabledChecked] = useState(tempLatchAllowed == null ? true : tempLatchAllowed);
    const [isTempLatchStandardRestrictionChecked, setIsTempLatchStandardRestrictionChecked] = useState(tempLatchStandardRestriction);
    const [accessLevelValue, setAccessLevelValue] = useState(accessLevel === "manager" || accessLevel === "admin" ? accessLevel : "user");
    const [isReadOnlyChecked, setIsReadOnlyChecked] = useState(readOnly)

    const [pinNameState, dispatchPinName] = useReducer(PinNameReducer, {
        value: DeviceDetails.pinName,
        isValid: null
    });

    const [onStatusState, dispatchOnStatus] = useReducer(onStatusReducer, {
        value: DeviceDetails.pinStatusOn,
        isValid: null
    });

    const [offStatusState, dispatchOffStatus] = useReducer(offStatusReducer, {
        value: DeviceDetails.pinStatusOff,
        isValid: null
    });

    const [action1OnState, dispatchAction1OnState] = useReducer(offStatusReducer, {
        value: DeviceDetails.actionOneOnLabel || "Disarm",
        isValid: null
    });

    const [action1OffState, dispatchAction1OffState] = useReducer(offStatusReducer, {
        value: DeviceDetails.actionOneOffLabel || "Arm",
        isValid: null
    });

    const [switchIconState, dispatchSwitchIcon] = useReducer(switchIconReducer, {
        showDropDownOptions: false,
        selectedOption: capitalizeFirstLetter(icon.toString()), // Initial selectedOption state
        icon: iconMap[icon],
        isValid: null
    });

    const { showDropDownOptions: showSwitchIconDropDownOptions, selectedOption: selectedSwitchIconOption, icon: SwitchIcon } = switchIconState;

    const [switchType, setSwitchType] = useState(type);
    const [switchTypeModified, setSwitchTypeModified] = useState(false);
    const [showReloadDialog, setShowReloadDialog] = useState(false);
    const [saveError, setSaveError] = useState("");


    const [pulseLengthState, dispatchPulseLength] = useReducer(PulseLengthReducer, {
        value: length != null && length !== '' ? String(length) : '',
        isValid: length != null && length !== '' ? true : null
    });

    const pinNameInputRef = useRef();
    const onStatusInputRef = useRef();
    const offStatusInputRef = useRef();
    const notificationsInputRef = useRef();
    const isPinActiveRef = useRef();
    const isTempLatchEnabledRef = useRef();
    const isTempLatchStandardRestrictionRef = useRef();
    const isReadyOnlyRef = useRef();
    const switchIconDropdownRef = useRef();
    const pulseLengthInputRef = useRef();
    const preAccessRef = useRef();

    const { isValid: pinNameIsValid } = pinNameState;
    const { isValid: onStatusIsValid } = onStatusState;
    const { isValid: offStatusIsValid } = offStatusState;
    const { isValid: switchIconIsValid } = switchIconState;
    const { isValid: pulseLengthIsValid } = pulseLengthState;

    useEffect(() => {
        if (!isPinActiveChecked) {
            setIsNotificationsChecked(false);
        } else {
            setIsNotificationsChecked(notificationActive);
        }
    }, [isPinActiveChecked]);

    useEffect(() => {
        const identifier = setTimeout(() => {
            // console.log('Checking form validity!');
            setFormIsValid(pinNameIsValid && onStatusIsValid && offStatusIsValid && switchIconIsValid, )
        }, 500);

        return () => {
            // console.log('CLEANUP');
            clearTimeout(identifier);
        };
    }, [pinNameIsValid, onStatusIsValid, offStatusIsValid, switchIconIsValid]);

    const pinNameChangeHandler = (event) => {
        dispatchPinName({ type: 'USER_INPUT', val: event.target.value });
        // console.log(event.target.value)
    }

    const onStatusChangeHandler = (event) => {
        dispatchOnStatus({ type: 'USER_INPUT', val: event.target.value });
        // console.log(event.target.value)
    }

    const offStatusChangeHandler = (event) => {
        dispatchOffStatus({ type: 'USER_INPUT', val: event.target.value });
        // console.log(event.target.value)
    }

    const action1OffStatusChangeHandler = (event) => {
        dispatchAction1OffState({ type: 'USER_INPUT', val: event.target.value });
        // console.log(event.target.value)
    }

    const action1OnStatusChangeHandler = (event) => {
        dispatchAction1OnState({ type: 'USER_INPUT', val: event.target.value });
        // console.log(event.target.value)
    }

    const validatePulseLengthHandler = () => {
        dispatchPulseLength({ type: 'INPUT_BLUR' });
    }

    const validatePinNameHandler = () => {
        dispatchPinName({ type: 'INPUT_BLUR' });
    }

    const validateOnStatusHandler = () => {
        dispatchOnStatus({ type: 'INPUT_BLUR' });
    }

    const validateAction1OnStatusHandler = () => {
        dispatchAction1OnState({ type: 'INPUT_BLUR' });
    }

    const validateAction1OffStatusHandler = () => {
        dispatchAction1OffState({ type: 'INPUT_BLUR' });
    }

    const validateOffStatusHandler = () => {
        dispatchOffStatus({ type: 'INPUT_BLUR' });
    }

    const pulseLengthChangeHandler = (event) => {
        dispatchPulseLength({ type: 'USER_INPUT', val: event.target.value });
        // console.log(event.target.value)
    }

    // Drop down handlers ---------------

    const handleSwitchIconDropDownOnClick = () => {
        dispatchSwitchIcon({ type: 'TOGGLE_DROPDOWN' });
    };

    const handleSwitchIconOptionChange = (option, icon) => {
        dispatchSwitchIcon({ type: 'SELECT_OPTION', payload: { option, icon } });
    };
    const handleSwitchIconBlur = () => {
        dispatchSwitchIcon({ type: 'BLUR_DROPDOWN' });
    };

    const onClearHandler = () => {
        dispatchPinName({ type: 'INPUT_CLEAR', val: "" })
        dispatchOnStatus({ type: 'INPUT_CLEAR', val: "" })
        dispatchOffStatus({ type: 'INPUT_CLEAR', val: "" })
        dispatchPulseLength({ type: 'INPUT_CLEAR', val: "" })
        // dispatchSwitchIcon({ type: 'SELECT_OPTION', payload: { option: capitalizeFirstLetter(icon.toString()), icon: iconMap[icon], } })
    }

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const performSave = () => {
            const PinName = pinNameState.value || pinName;
            const onStatus = onStatusState.value || pinStatusOn;
            const offStatus = offStatusState.value || pinStatusOff;
            const actionOneOnLabel = action1OnState.value || actionOneOnLabel;
            const actionOneOffLabel = action1OffState.value || actionOneOffLabel;
            const notificationsChecked = isNotificationsChecked ? 1 : 0;
            const pinActive = isPinActiveChecked ? 1 : 0;
            const isReadOnly = isReadOnlyChecked ? true : false
            const isTempLatchAllowed = isTempLatchEnabledChecked ? true : false
            const isTempLatchStandardRestriction = isTempLatchStandardRestrictionChecked ? true : false
            const switchIcon = switchIconState.selectedOption || icon;
            const SwitchType = switchType || type;
            const PulseLength = (parseInt(pulseLengthState.value) || length);
            const preAccessCheck = isPreAccessChecked ? true : false;

            const DeviceDetails = {
                [Pin]: {
                    "notificationActive": notificationsChecked,
                    "pinState": pinState,
                    "delay": delay,
                    "lastSwitchTime": lastSwitchTime,
                    "notificationSound": notificationSound,
                    "length": PulseLength,
                    "active": pinActive,
                    "pinName": PinName,
                    "pinStatusOff": offStatus,
                    "type": SwitchType,
                    "pinStatusOn": onStatus,
                    "actionOneOnLabel": actionOneOnLabel,
                    "actionOneOffLabel": actionOneOffLabel,
                }
            }

            const DeviceDetailsExtra = {
                [Pin]:
                {
                    "icon": switchIcon.toLowerCase() + ".png",
                    "preAccessCheck": preAccessCheck,
                    "accessLevel": accessLevelValue,
                    "readOnly" : isReadOnly,
                    "tempLatchAllowed": isTempLatchAllowed,
                    "tempLatchStandardRestriction": isTempLatchStandardRestriction
                },
            }
            setNewDeviceDetails(DeviceDetails);
            setNewDeviceDetailsExtras(DeviceDetailsExtra);
            setReloadOnSave && setReloadOnSave(switchTypeModified);
    }

    const submitHandler = (event) => {
        event.preventDefault();
        if (switchType === "PULSE") {
            const pulseVal = parseInt(pulseLengthState.value, 10);
            if (!pulseLengthState.value || isNaN(pulseVal) || pulseVal <= 0) {
                dispatchPulseLength({ type: 'INPUT_BLUR' });
                setSaveError("Pulse length must be greater than 0.");
                return;
            }
        }
        setSaveError("");
        if (switchTypeModified) {
            setShowReloadDialog(true);
            return;
        }
        performSave();

            // if ((pinNameState.value != "" && pinNameState.value != pinName) ||
            //     (onStatusState.value != "" && onStatusState.value != pinStatusOn) ||
            //     (offStatusState.value != "" && offStatusState != pinStatusOff) ||
            //     (notificationsChecked != notificationActive) ||
            //     (isPinActiveChecked != active) ||
            //     (switchType != type) ||
            //     (pulseLengthState.value) != "") {
                
            //     console.log(DeviceDetails)
            //     console.log("set")
            // }

            // if (switchIconState.selectedOption != "" 
            //     && switchIconState.selectedOption.toLowerCase() != icon || 
            //     (isManagerOnlyChecked != (accessLevel === "user" ? false : true))) {
                    
            //         console.log("set")
            // }

            // onClearHandler() ;#c8f8c8

             return;
        // } else if (!pinNameIsValid) {
        //     pinNameInputRef.current.focus();
        // } else if (!onStatusIsValid) {
        //     onStatusInputRef.current.focus(); // Corrected from !onStatusState
        // } else if (!offStatusIsValid) {
        //     offStatusInputRef.current.focus();
        // } else if (!switchIconIsValid) {
        //     switchIconDropdownRef.current.focus();
        // } else if (!pulseLengthIsValid) {
        //     pulseLengthInputRef.current.focus();
        // }
    };

    let [PulseLength, setPulseLength] = useState(length)
    useEffect(() => {
        if (pulseLengthState.value == "") {
            setPulseLength(length);
        } else {
            setPulseLength(pulseLengthState.value);
        }

    }, [pulseLengthState.value])

    // Example usage:
    const seconds = 61;

    if (PulseLength <= 59) {
        PulseLength = PulseLength + "s";
    } else if (PulseLength > 59) {
        PulseLength = PulseLength + "s" + " ( " + convertSecondsToMinutesAndSeconds(PulseLength) + ")";
    }

    return (
        <Fragment>
        <Dialog
            header="Page reload required"
            visible={showReloadDialog}
            onHide={() => setShowReloadDialog(false)}
            style={{ width: '360px' }}
        >
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "12px" }}>
                <p style={{ textAlign: "center", color: "#858585", fontSize: "15px", margin: 0 }}>
                    Changing the switch type requires the page to reload to apply changes.
                </p>
                <div style={{ display: "flex", gap: "10px" }}>
                    <Button icon="pi pi-times" label="Cancel" severity="secondary" onClick={() => setShowReloadDialog(false)} />
                    <Button icon="pi pi-save" label="Save & reload" severity="success" onClick={() => { setShowReloadDialog(false); performSave(); }} />
                </div>
            </div>
        </Dialog>
        <form onSubmit={submitHandler} className={classes["container"]} method="dialog" >
            <button className={classes.submitButton} type="submit">Save</button>
            {saveError && <p style={{ color: "#e05252", fontSize: "13px", margin: "6px 0 0 0" }}>{saveError}</p>}
            <br></br>
            <ul className={classes["inputs-list"]}>
                {/* <li className={classes["input-container"]}> */}
                {/* <label className={classes.subTitle} >Name</label>
                    <Input
                        className={classes.input}
                        placeholder={pinName || "Enter Pin Name..."}
                        ref={pinNameInputRef}
                        id="PinName"
                        type={"text"}
                        isValid={pinNameState.isValid}
                        value={pinNameState.value}
                        onChange={pinNameChangeHandler}
                        onBlur={validatePinNameHandler}
                        style={{backgroundColor: "var(--Primary-Color-SiteView)", color: "white", placeholder: "red"}}
                    />
                </li> */}

                <ToggleInput
                    propsClassName={classes.toggleInput}
                    label={"Visible in app"}
                    ref={isPinActiveRef}
                    type="checkbox"
                
                    isChecked={isPinActiveChecked}
                    setIsChecked={setIsPinActiveChecked}

                />

                {!PinDetails.InputPin && !isPadlockOutput && switchType !== "PULSE" && <ToggleInput
                    propsClassName={classes.toggleInput}
                    label={"Temp actions enabled"}
                    ref={isTempLatchEnabledRef}
                    type="checkbox"
                    isChecked={isTempLatchEnabledChecked}
                    setIsChecked={setIsTempLatchEnabledChecked}
                />}

                {!PinDetails.InputPin && !isPadlockOutput && switchType !== "PULSE" && isTempLatchEnabledChecked && <ToggleInput
                    propsClassName={classes.toggleInput}
                    label={"Standard users restricted to temp action"}
                    ref={isTempLatchStandardRestrictionRef}
                    type="checkbox"
                    isChecked={isTempLatchStandardRestrictionChecked}
                    setIsChecked={setIsTempLatchStandardRestrictionChecked}
                /> }

                {isPinActiveChecked == 1 && <div className={classes.toggleInput}>
                    <label>Access level</label>
                    <SelectButton
                        className={classes.accessLevelToggle}
                        value={accessLevelValue}
                        options={accessLevelOptions}
                        onChange={(e) => e.value && setAccessLevelValue(e.value)}
                    />
                </div> }

                {(isPinActiveChecked == 1 && accessLevelValue !== "user") && <ToggleInput
                    propsClassName={classes.toggleInput}
                    label={"Viewable by standard user"}
                    ref={isReadyOnlyRef}
                    type="checkbox"
                    isChecked={isReadOnlyChecked}
                    setIsChecked={setIsReadOnlyChecked}
                    style={{ backgroundColor: "red" }}
                /> }

                <ToggleInput
                    propsClassName={classes.toggleInput}
                    label={"Notifications"}
                    ref={notificationsInputRef}
                    type="checkbox"
                    isChecked={isNotificationsChecked}
                    setIsChecked={setIsNotificationsChecked}
                />

                {!PinDetails.InputPin && isPadlockOutput && (
                    <ToggleInput 
                        propsClassName={classes.toggleInput}
                        label={"Pre-access check"}
                        ref={preAccessRef}
                        type="checkbox"
                        isChecked={isPreAccessChecked}
                        setIsChecked={setIsPreAccessChecked}
                    />
                )}

                <li className={classes["input-container"]}>
                    <label className={classes.subTitle}>Name</label>
                    <Input
                        propsClassName={classes.input}
                        placeholder={pinName || "Enter Pin Name..."}
                        ref={pinNameInputRef}
                        id="PinName"
                        type={"text"}
                        maxLength={17}
                        isValid={pinNameState.isValid}
                        value={pinNameState.value}
                        onChange={pinNameChangeHandler}
                        onBlur={validatePinNameHandler}
                    />
                </li>

                {switchType !== "PULSE" && <li className={classes["input-container"]}>
                    <label className={classes.subTitle}>On Status Name</label>
                    <Input
                        propsClassName={classes.input}
                        placeholder={pinStatusOn || "On Status Name"}
                        ref={onStatusInputRef}
                        id="OnStatus"
                        type={"text"}
                        maxLength={17}
                        isValid={onStatusState.isValid}
                        value={onStatusState.value}
                        onChange={onStatusChangeHandler}
                        onBlur={validateOnStatusHandler}
                    />
                </li>}
                
                {!PinDetails.InputPin && !isPadlockOutput && <li className={classes["input-container"]}>
                    <label className={classes.subTitle}>{switchType === "PULSE" ? "Pulse Action Button" : "On Action Button Name"}</label>
                        <Input
                            propsClassName={classes.input}
                            placeholder={actionOneOnLabel || "On Action Button name"}
                            ref={onStatusInputRef}
                            id="Action1OnStatus"
                            type={"text"}
                            maxLength={17}
                            isValid={action1OnState.isValid}
                            value={action1OnState.value}
                            onChange={action1OnStatusChangeHandler}
                            onBlur={validateAction1OnStatusHandler}
                        />
                    </li>}

                {switchType !== "PULSE" && <li className={classes["input-container"]}>
                    <label className={classes.subTitle}>Off Status Name</label>
                    <Input
                        propsClassName={classes.input}
                        placeholder={pinStatusOff || "Off Status Name"}
                        ref={offStatusInputRef}
                        id="offStatus"
                        type={"offStatus"}
                        maxLength={17}
                        isValid={offStatusState.isValid}
                        value={offStatusState.value}
                        onChange={offStatusChangeHandler}
                        onBlur={validateOffStatusHandler}
                    />
                </li>}

                {!PinDetails.InputPin && !isPadlockOutput && switchType !== "PULSE" && <li className={classes["input-container"]}>
                    <label className={classes.subTitle}>Off Action Button Name</label>
                    <Input
                        propsClassName={classes.input}
                        placeholder={actionOneOffLabel || "Off Action Button Name"}
                        ref={offStatusInputRef}
                        id="Action1OffStatus"
                        type={"offStatus"}
                        maxLength={17}
                        isValid={action1OffState.isValid}
                        value={action1OffState.value}
                        onChange={action1OffStatusChangeHandler}
                        onBlur={validateAction1OffStatusHandler}
                    />
                </li>}

                {!isPadlockOutput && (
                    <li className={classes["input-container"]} style={{ padding: "5px", position: "relative" }}>
                        <label className={classes.subTitle} >Switch Icon</label>

                        <SelectIcon
                            propsClassName={classes.dropdown}
                            propsImgClassName={classes.img}
                            style={{ marginTop: "30px" }}
                            placeholder={"Door"}
                            options={['Camera', 'Gate', 'Door', 'Alarm', 'Default', 'Speaker']}
                            icons={iconMap}
                            selectedOption={selectedSwitchIconOption}
                            selectedIcon={SwitchIcon}
                            handleOptionChange={handleSwitchIconOptionChange}
                            handleBlur={handleSwitchIconBlur}
                            handleDropDownOnClick={handleSwitchIconDropDownOnClick}
                            showDropDownOptions={showSwitchIconDropDownOptions}
                            isValid={switchIconIsValid}
                            ref={switchIconDropdownRef}
                        />
                    </li>
                )}

                {/* Only show Switch Type Section if pin click was a output */}
                {!PinDetails.InputPin && !isPadlockOutput && <li className={classes["input-container"]} >
                    <label className={classes.subTitle} >Switch Type</label>
                    <div style={{ display: "flex", gap: "20px", alignItems: "center", paddingTop: "10px" }} >
                        <Button1 type="button" style={{ backgroundColor: switchType == "LATCH" ? "var(--Primary-Color)" : "#cdcdcd" , color: "white"  }} onClick={() => { setSwitchType("LATCH"); setSwitchTypeModified("LATCH" !== type); }} >Latch</Button1>
                        <Button1 type="button" style={{ backgroundColor: switchType == "PULSE" ? "var(--Primary-Color)" : "#cdcdcd", color: "white"}} onClick={() => { setSwitchType("PULSE"); setSwitchTypeModified("PULSE" !== type); }}> Pulse</Button1>

                        {/* Pulse Length Input */}

                        {switchType == "PULSE" && <h3 style={{ fontWeight: "400", fontSize: "15px", color: "white" }}>{PulseLength}</h3>}

                    </div>
                    {switchType == "PULSE" && <Input
                        propsClassName={classes.input}
                        placeholder={"Enter pulse length in seconds..."}
                        ref={pulseLengthInputRef}
                        id="pulseLengthInput"
                        type={"text"}
                        isValid={pulseLengthState.isValid}
                        value={pulseLengthState.value}
                        onChange={pulseLengthChangeHandler}
                        onBlur={validatePulseLengthHandler}
                    />}
                </li>}



                
            </ul>

        </form >
        </Fragment>
    )


}

export default EditPinForm;

